import PropTypes from 'prop-types'
import img_tooltipMasterWorkHeader from './../assets/img/tooltipMasterworkHeader.png'
import img_primaryAmmo from './../assets/img/ammo-primary.png'
import img_specialAmmo from './../assets/img/ammo-special.png'
import img_heavyAmmo from './../assets/img/ammo-heavy.png'
import img_arcEnergy from './../assets/img/arc.png'
import img_solarEnergy from './../assets/img/solar.png'
import img_voidEnergy from './../assets/img/void.png'
import img_stasisEnergy from './../assets/img/stasis.png'
import img_placeholderIcon from './../assets/img/placeholder-icon.png'
import { React, useState, useEffect } from 'react';
import { Radio, RadioGroup, FormControl, FormLabel, Button, ButtonGroup, Checkbox, FormControlLabel, FormGroup, TextField, Slider, Backdrop } from '@mui/material'

const DestinyTooltip = (props) => {
  const [masterwork, set_masterwork] = useState(props.masterwork) // Exotic Izanagi's Burden
  const [header_background_color, set_header_background_color] = useState(props.header_background_color) // Exotic Izanagi's Burden
  const [box_background_color, set_box_background_color] = useState(props.box_background_color) // Exotic Izanagi's Burden
  const [header_title_text, set_header_title_text] = useState(props.header_title_text) // Exotic Izanagi's Burden
  const [header_title_text_color, set_header_title_text_color] = useState(props.header_title_text_color) // Exotic Izanagi's Burden
  const [header_subtitle_text, set_header_subtitle_text] = useState(props.header_subtitle_text) // Exotic Izanagi's Burden
  const [header_subtitle_text_color, set_header_subtitle_text_color] = useState(props.header_subtitle_text_color) // Exotic Izanagi's Burden
  const [header_subtitle_rarity_text, set_header_subtitle_rarity_text] = useState(props.header_subtitle_rarity_text) // Exotic Izanagi's Burden
  const [header_subtitle_rarity_text_color, set_header_subtitle_rarity_text_color] = useState(props.header_subtitle_rarity_text_color) // Exotic Izanagi's Burden
  const [header_missingRequirementWarning_text, set_header_missingRequirementWarning_text] = useState(props.header_missingRequirementWarning_text) // Exotic Izanagi's Burden
  const [header_description, set_header_description] = useState(props.header_description)
  const [item_bool, set_item_bool] = useState(props.item_bool)
  const [item_power_text, set_item_power_text] = useState(props.item_power_text)
  const [item_power_text_color, set_item_power_text_color] = useState(props.item_power_text_color)
  const [item_energydamagetype, set_item_energydamagetype] = useState(props.item_energydamagetype)
  const [item_weaponTypeBool, set_item_weaponTypeBool] = useState(props.item_weaponTypeBool)
  const [item_weaponammotype, set_item_weaponammotype] = useState(props.item_weaponammotype)
  const [item_ammotype_text, set_item_ammotype_text] = useState(props.item_ammotype_text)
  const [item_ammotype_text_color, set_item_ammotype_text_color] = useState(props.item_ammotype_text_color)
  const [item_armorbool, set_item_armorbool] = useState(props.item_armorbool)
  const [item_armorAffinitytype, set_item_armorAffinitytype] = useState(props.item_armorAffinitytype)
  const [item_armorAffinity_number_text, set_item_armorAffinity_number_text] = useState(props.item_armorAffinity_number_text)
  const [item_armorAffinity_number_color, set_item_armorAffinity_number_color] = useState(props.item_armorAffinity_number_color)
  const [item_armorAffinity_text, set_item_armorAffinity_text] = useState(props.item_armorAffinity_text)
  const [item_armorAffinity_text_color, set_item_armorAffinity_text_color] = useState(props.item_armorAffinity_text_color)
  const [item_craftedBool, set_item_craftedBool] = useState(props.item_craftedBool)
  const [item_craftedWeaponProgressBarText, set_item_craftedWeaponProgressBarText] = useState(props.item_craftedWeaponProgressBarText)
  const [item_craftedWeaponProgressBarPercentageText, set_item_craftedWeaponProgressBarPercentageText] = useState(props.item_craftedWeaponProgressBarPercentageText)
  const [item_craftedWeaponProgressBarPercentageValue, set_item_craftedWeaponProgressBarPercentageValue] = useState(props.item_craftedWeaponProgressBarPercentageValue)
  const [item_killTracker_bool, set_item_killTracker_bool] = useState(props.item_killTracker_bool)
  const [item_killTrackerIconLink, set_item_killTrackerIconLink] = useState(props.item_killTrackerIconLink)
  const [item_killTrackerName_text, set_item_killTrackerName_text] = useState(props.item_killTrackerName_text)
  const [item_killTrackerName_text_color, set_item_killTrackerName_text_color] = useState(props.item_killTrackerName_text_color)
  const [item_killTrackerValue_text, set_item_killTrackerValue_text] = useState(props.item_killTrackerValue_text)
  const [item_killTrackerValue_text_color, set_item_killTrackerValue_text_color] = useState(props.item_killTrackerValue_text_color)
  const [item_statBox_bool, set_item_statBox_bool] = useState(props.item_statBox_bool)

  const [item_statBox_stat1_name_text, set_item_statBox_stat1_name_text] = useState(props.item_statBox_stat1_name_text)
  const [item_statBox_stat1_barBase_value, set_item_statBox_stat1_barBase_value] = useState(props.item_statBox_stat1_barBase_value)
  const [item_statBox_stat1_barMasterwork_value, set_item_statBox_stat1_barMasterwork_value] = useState(props.item_statBox_stat1_barMasterwork_value)
  const [item_statBox_stat1_value_text, set_item_statBox_stat1_value_text] = useState(props.item_statBox_stat1_value_text)
  const [item_statBox_stat1_value_masterwork, set_item_statBox_stat1_value_masterwork] = useState(props.item_statBox_stat1_value_masterwork)

  const [item_statBox_stat2_name_text, set_item_statBox_stat2_name_text] = useState(props.item_statBox_stat2_name_text)
  const [item_statBox_stat2_barBase_value, set_item_statBox_stat2_barBase_value] = useState(props.item_statBox_stat2_barBase_value)
  const [item_statBox_stat2_barMasterwork_value, set_item_statBox_stat2_barMasterwork_value] = useState(props.item_statBox_stat2_barMasterwork_value)
  const [item_statBox_stat2_value_text, set_item_statBox_stat2_value_text] = useState(props.item_statBox_stat2_value_text)
  const [item_statBox_stat2_value_masterwork, set_item_statBox_stat2_value_masterwork] = useState(props.item_statBox_stat2_value_masterwork)

  const [item_statBox_stat3_name_text, set_item_statBox_stat3_name_text] = useState(props.item_statBox_stat3_name_text)
  const [item_statBox_stat3_barBase_value, set_item_statBox_stat3_barBase_value] = useState(props.item_statBox_stat3_barBase_value)
  const [item_statBox_stat3_barMasterwork_value, set_item_statBox_stat3_barMasterwork_value] = useState(props.item_statBox_stat3_barMasterwork_value)
  const [item_statBox_stat3_value_text, set_item_statBox_stat3_value_text] = useState(props.item_statBox_stat3_value_text)
  const [item_statBox_stat3_value_masterwork, set_item_statBox_stat3_value_masterwork] = useState(props.item_statBox_stat3_value_masterwork)

  const [item_statBox_stat4_name_text, set_item_statBox_stat4_name_text] = useState(props.item_statBox_stat4_name_text)
  const [item_statBox_stat4_barBase_value, set_item_statBox_stat4_barBase_value] = useState(props.item_statBox_stat4_barBase_value)
  const [item_statBox_stat4_barMasterwork_value, set_item_statBox_stat4_barMasterwork_value] = useState(props.item_statBox_stat4_barMasterwork_value)
  const [item_statBox_stat4_value_text, set_item_statBox_stat4_value_text] = useState(props.item_statBox_stat4_value_text)
  const [item_statBox_stat4_value_masterwork, set_item_statBox_stat4_value_masterwork] = useState(props.item_statBox_stat4_value_masterwork)

  const [item_statBox_stat5_name_text, set_item_statBox_stat5_name_text] = useState(props.item_statBox_stat5_name_text)
  const [item_statBox_stat5_barBase_value, set_item_statBox_stat5_barBase_value] = useState(props.item_statBox_stat5_barBase_value)
  const [item_statBox_stat5_barMasterwork_value, set_item_statBox_stat5_barMasterwork_value] = useState(props.item_statBox_stat5_barMasterwork_value)
  const [item_statBox_stat5_value_text, set_item_statBox_stat5_value_text] = useState(props.item_statBox_stat5_value_text)
  const [item_statBox_stat5_value_masterwork, set_item_statBox_stat5_value_masterwork] = useState(props.item_statBox_stat5_value_masterwork)

  const [item_statBox_stat6_name_text, set_item_statBox_stat6_name_text] = useState(props.item_statBox_stat6_name_text)
  const [item_statBox_stat6_barBase_value, set_item_statBox_stat6_barBase_value] = useState(props.item_statBox_stat6_barBase_value)
  const [item_statBox_stat6_barMasterwork_value, set_item_statBox_stat6_barMasterwork_value] = useState(props.item_statBox_stat6_barMasterwork_value)
  const [item_statBox_stat6_value_text, set_item_statBox_stat6_value_text] = useState(props.item_statBox_stat6_value_text)
  const [item_statBox_stat6_value_masterwork, set_item_statBox_stat6_value_masterwork] = useState(props.item_statBox_stat6_value_masterwork)

  const [item_statBox_stat7_name_text, set_item_statBox_stat7_name_text] = useState(props.item_statBox_stat7_name_text)
  const [item_statBox_stat7_barBase_value, set_item_statBox_stat7_barBase_value] = useState(props.item_statBox_stat7_barBase_value)
  const [item_statBox_stat7_barMasterwork_value, set_item_statBox_stat7_barMasterwork_value] = useState(props.item_statBox_stat7_barMasterwork_value)
  const [item_statBox_stat7_value_text, set_item_statBox_stat7_value_text] = useState(props.item_statBox_stat7_value_text)
  const [item_statBox_stat7_value_masterwork, set_item_statBox_stat7_value_masterwork] = useState(props.item_statBox_stat7_value_masterwork)

  const [item_statBox_stat8_name_text, set_item_statBox_stat8_name_text] = useState(props.item_statBox_stat8_name_text)
  const [item_statBox_stat8_barBase_value, set_item_statBox_stat8_barBase_value] = useState(props.item_statBox_stat8_barBase_value)
  const [item_statBox_stat8_barMasterwork_value, set_item_statBox_stat8_barMasterwork_value] = useState(props.item_statBox_stat8_barMasterwork_value)
  const [item_statBox_stat8_value_text, set_item_statBox_stat8_value_text] = useState(props.item_statBox_stat8_value_text)
  const [item_statBox_stat8_value_masterwork, set_item_statBox_stat8_value_masterwork] = useState(props.item_statBox_stat8_value_masterwork)

  const [item_statBox_stat9_name_text, set_item_statBox_stat9_name_text] = useState(props.item_statBox_stat9_name_text)
  const [item_statBox_stat9_barBase_value, set_item_statBox_stat9_barBase_value] = useState(props.item_statBox_stat9_barBase_value)
  const [item_statBox_stat9_barMasterwork_value, set_item_statBox_stat9_barMasterwork_value] = useState(props.item_statBox_stat9_barMasterwork_value)
  const [item_statBox_stat9_value_text, set_item_statBox_stat9_value_text] = useState(props.item_statBox_stat9_value_text)
  const [item_statBox_stat9_value_masterwork, set_item_statBox_stat9_value_masterwork] = useState(props.item_statBox_stat9_value_masterwork)

  const [item_statBox_stat10_name_text, set_item_statBox_stat10_name_text] = useState(props.item_statBox_stat10_name_text)
  const [item_statBox_stat10_barBase_value, set_item_statBox_stat10_barBase_value] = useState(props.item_statBox_stat10_barBase_value)
  const [item_statBox_stat10_barMasterwork_value, set_item_statBox_stat10_barMasterwork_value] = useState(props.item_statBox_stat10_barMasterwork_value)
  const [item_statBox_stat10_value_text, set_item_statBox_stat10_value_text] = useState(props.item_statBox_stat10_value_text)
  const [item_statBox_stat10_value_masterwork, set_item_statBox_stat10_value_masterwork] = useState(props.item_statBox_stat10_value_masterwork)


  const [item_modBox_bool, set_item_modBox_bool] = useState(props.item_modBox_bool)

  const [item_modBox_mod1_iconLink, set_item_modBox_mod1_iconLink] = useState(props.item_modBox_mod1_iconLink)
  const [item_modBox_mod1_name_text, set_item_modBox_mod1_name_text] = useState(props.item_modBox_mod1_name_text)
  const [item_modBox_mod1_description_text, set_item_modBox_mod1_description_text] = useState(props.item_modBox_mod1_description_text)
  const [item_modBox_mod1_type, set_item_modBox_mod1_type] = useState(props.item_modBox_mod1_type)

  const [item_modBox_mod2_iconLink, set_item_modBox_mod2_iconLink] = useState(props.item_modBox_mod2_iconLink)
  const [item_modBox_mod2_name_text, set_item_modBox_mod2_name_text] = useState(props.item_modBox_mod2_name_text)
  const [item_modBox_mod2_description_text, set_item_modBox_mod2_description_text] = useState(props.item_modBox_mod2_description_text)
  const [item_modBox_mod2_type, set_item_modBox_mod2_type] = useState(props.item_modBox_mod2_type)

  const [item_modBox_mod3_iconLink, set_item_modBox_mod3_iconLink] = useState(props.item_modBox_mod3_iconLink)
  const [item_modBox_mod3_name_text, set_item_modBox_mod3_name_text] = useState(props.item_modBox_mod3_name_text)
  const [item_modBox_mod3_description_text, set_item_modBox_mod3_description_text] = useState(props.item_modBox_mod3_description_text)
  const [item_modBox_mod3_type, set_item_modBox_mod3_type] = useState(props.item_modBox_mod3_type)

  const [item_modBox_mod4_iconLink, set_item_modBox_mod4_iconLink] = useState(props.item_modBox_mod4_iconLink)
  const [item_modBox_mod4_name_text, set_item_modBox_mod4_name_text] = useState(props.item_modBox_mod4_name_text)
  const [item_modBox_mod4_description_text, set_item_modBox_mod4_description_text] = useState(props.item_modBox_mod4_description_text)
  const [item_modBox_mod4_type, set_item_modBox_mod4_type] = useState(props.item_modBox_mod4_type)

  const [item_modBox_mod5_iconLink, set_item_modBox_mod5_iconLink] = useState(props.item_modBox_mod5_iconLink)
  const [item_modBox_mod5_name_text, set_item_modBox_mod5_name_text] = useState(props.item_modBox_mod5_name_text)
  const [item_modBox_mod5_description_text, set_item_modBox_mod5_description_text] = useState(props.item_modBox_mod5_description_text)
  const [item_modBox_mod5_type, set_item_modBox_mod5_type] = useState(props.item_modBox_mod5_type)

  const [item_modBox_mod6_iconLink, set_item_modBox_mod6_iconLink] = useState(props.item_modBox_mod6_iconLink)
  const [item_modBox_mod6_name_text, set_item_modBox_mod6_name_text] = useState(props.item_modBox_mod6_name_text)
  const [item_modBox_mod6_description_text, set_item_modBox_mod6_description_text] = useState(props.item_modBox_mod6_description_text)
  const [item_modBox_mod6_type, set_item_modBox_mod6_type] = useState(props.item_modBox_mod6_type)

  const [item_modBox_mod7_iconLink, set_item_modBox_mod7_iconLink] = useState(props.item_modBox_mod7_iconLink)
  const [item_modBox_mod7_name_text, set_item_modBox_mod7_name_text] = useState(props.item_modBox_mod7_name_text)
  const [item_modBox_mod7_description_text, set_item_modBox_mod7_description_text] = useState(props.item_modBox_mod7_description_text)
  const [item_modBox_mod7_type, set_item_modBox_mod7_type] = useState(props.item_modBox_mod7_type)

  const [item_modBox_mod8_iconLink, set_item_modBox_mod8_iconLink] = useState(props.item_modBox_mod8_iconLink)
  const [item_modBox_mod8_name_text, set_item_modBox_mod8_name_text] = useState(props.item_modBox_mod8_name_text)
  const [item_modBox_mod8_description_text, set_item_modBox_mod8_description_text] = useState(props.item_modBox_mod8_description_text)
  const [item_modBox_mod8_type, set_item_modBox_mod8_type] = useState(props.item_modBox_mod8_type)

  const [item_modBox_mod9_iconLink, set_item_modBox_mod9_iconLink] = useState(props.item_modBox_mod9_iconLink)
  const [item_modBox_mod9_name_text, set_item_modBox_mod9_name_text] = useState(props.item_modBox_mod9_name_text)
  const [item_modBox_mod9_description_text, set_item_modBox_mod9_description_text] = useState(props.item_modBox_mod9_description_text)
  const [item_modBox_mod9_type, set_item_modBox_mod9_type] = useState(props.item_modBox_mod9_type)

  const [item_modBox_mod10_iconLink, set_item_modBox_mod10_iconLink] = useState(props.item_modBox_mod10_iconLink)
  const [item_modBox_mod10_name_text, set_item_modBox_mod10_name_text] = useState(props.item_modBox_mod10_name_text)
  const [item_modBox_mod10_description_text, set_item_modBox_mod10_description_text] = useState(props.item_modBox_mod10_description_text)
  const [item_modBox_mod10_type, set_item_modBox_mod10_type] = useState(props.item_modBox_mod10_type)

  const [footer_text, set_footer_text] = useState(props.footer_text)
  const [footer_textColor, set_footer_textColor] = useState(props.footer_textColor)
  const [footer_backgroundColor, set_footer_backgroundColor] = useState(props.footer_backgroundColor)

  const [open, setOpen] = useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleToggle = () => {
    setOpen(!open);
  };

  const [isMobile, setIsMobile] = useState(false);
    useEffect(() => {
      window.screen.width <= 1160 ? setIsMobile(true) : setIsMobile(false);
    }, [window.screen.width]); // eslint-disable-line

    function detectWindowSize() {
        window.innerWidth <= 1160 ? setIsMobile(true) : setIsMobile(false);
    }

    window.onresize = detectWindowSize;

  function layoutSetExotic() {
    set_header_background_color('#c0a339')
    set_box_background_color('#272417')
    set_header_title_text_color('#ffffff')
    set_header_subtitle_text_color('#e5d9af')
    set_header_subtitle_rarity_text('Exotic')
    set_header_subtitle_rarity_text_color('#e3d14d')
  }
  function layoutSetLegendary() {
    set_header_background_color('#533d66')
    set_box_background_color('#221e25')
    set_header_title_text_color('#ffffff')
    set_header_subtitle_text_color('#b9b0c0')
    set_header_subtitle_rarity_text('Legendary')
    set_header_subtitle_rarity_text_color('#9e8ea9')
  }
  function layoutSetRare() {
    set_header_background_color('#517692')
    set_box_background_color('#1a2027')
    set_header_title_text_color('#ffffff')
    set_header_subtitle_text_color('#b9c8d3')
    set_header_subtitle_rarity_text('Rare')
    set_header_subtitle_rarity_text_color('#7aabca')
  }
  function layoutSetUncommon() {
    set_header_background_color('#32653d')
    set_box_background_color('#161d18')
    set_header_title_text_color('#ffffff')
    set_header_subtitle_text_color('#adc1b1')
    set_header_subtitle_rarity_text('Uncommon')
    set_header_subtitle_rarity_text_color('#80c679')
  }
  function layoutSetCommon() {
    set_header_background_color('#b3ada7')
    set_box_background_color('#1d1c1d')
    set_header_title_text_color('#000000')
    set_header_subtitle_text_color('#4a4845')
    set_header_subtitle_rarity_text('')
    set_header_subtitle_rarity_text_color('#524D47')
  }
  function layoutSetBasic() {
    set_header_background_color('#0d0d0e')
    set_box_background_color('#212122')
    set_header_title_text_color('#ffffff')
    set_header_subtitle_text_color('#9d9d9d')
    set_header_subtitle_rarity_text('')
    set_header_subtitle_rarity_text_color('#9d9d9d')
  }

  const headerBoxStyle_MasterworkStyle = {
    background: header_background_color + " url(" + img_tooltipMasterWorkHeader + ") 0px 0px/contain no-repeat",
    margin: '0px',
    paddingLeft: '1.55em',
  }

  const headerBoxStyle = {
    margin: '0px',
    background: header_background_color,
    paddingLeft: '0.58em',
  }

  const headerBoxTitleStyle = {
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    textTransform: 'uppercase',
    paddingTop: '0.48em',
    paddingRight: '0.4em',
    paddingBottom: '0em',
    letterSpacing: '0.07em',
    fontSize: '2.75em',
    fontWeight: '600',
    lineHeight: '1.08em',
    wordSpacing: '0.02em'
  }

  const headerBoxSubTitleBoxStyle = {
    paddingTop: '0em',
    paddingBottom: '0.5em',
    lineHeight: '2.45em'
  }

  const headerBoxSubTitleStyle = {
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    letterSpacing: '0.01em',
    fontSize: '1.9em',
    display: 'inline-block',
    wordSpacing: '0.08em'
  }

  const headerBoxSubTitleRarityStyle = {
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    letterSpacing: '0.01em',
    fontSize: '1.9em',
    textAlign: 'right',
    float: 'right',
    paddingRight: '0.8em',
    display: 'relative',
    wordSpacing: '0.08em',
    lineHeight: '1.2em'
  }

  const headerMissingRequirementWarningStyle = {
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    letterSpacing: '0.03em',
    backgroundColor: '#8a4142',
    color: '#ffffff',
    fontSize: '1.85em',
    paddingTop: '0.12em',
    paddingBottom: '0.12em',
    paddingLeft: '0.9em',
    paddingRight: '0.8em',
    wordSpacing: '0.08em'
  }

  const descriptionStyle = {
    paddingTop: '0.4em',
    paddingLeft: '0.9em',
    paddingRight: '0.9em',
    paddingBottom: '0.7em',
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    fontSize: '1.85em',
    letterSpacing: '0.03em',
    color: '#cdcdcd',
    lineHeight: '1.2em',
    borderBottom: '0.1em solid #5c5950aa',
    wordSpacing: '0.08em'
  }

  const itemPrimaryStatBoxStyle = {
    paddingRight: '0em',
    marginTop: '0em',
    paddingBottom: '0.25em',
    borderBottom: '0.15em solid #5c5950'
  }

  const itemPrimaryStatPowerStyle = {
    fontFamily: 'NHaasGroteskDSPro-75Bd, DestinySymbols',
    fontSize: '5.2em',
    letterSpacing: '0.0075em',
    lineHeight: '1em',
    marginTop: '0.11em',
    display: 'inline-block',
    marginLeft: '0.29em',
  }

  const itemPrimaryStatPowerNumberStyle = {
    color: item_power_text_color,
    paddingRight: '0.30em',
    borderRight: '0.04em solid #5e5b52',
    display: 'inline-block',
    lineHeight: '0.71em',
    height: '0.72em'
  }

  const itemPrimaryStatAmmoTypeStyle = {
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    textTransform: 'uppercase',
    letterSpacing: '0.02em',
    fontSize: '1.9em',
    display: 'inline-block',
    paddingLeft: '0.75em'
  }

  const itemPrimaryStatAmmoTypeTextStyle = {
    color: item_ammotype_text_color,
    paddingLeft: '0.74em',
    verticalAlign: '0.62em'
  }

  const itemPrimaryStatArmorEnergyTypeStyle = {
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    textTransform: 'uppercase',
    letterSpacing: '0.04em',
    fontSize: '1.8em',
    display: 'inline-block',
    paddingLeft: '0.86em',
    verticalAlign: '0.01em'
  }

  const itemEnergyaffinityNumberStyle = {
    fontFamily: 'NHaasGroteskDSPro-75Bd, DestinySymbols',
    fontSize: '1.65em',
    color: item_armorAffinity_number_color,
    letterSpacing: '0em',
    paddingLeft: '0.1em',
    verticalAlign: '0.24em'
  }

  const itemCraftedWeaponProgressBoxStyle = {
    display: 'flex',
    position: 'relative',
    backgroundColor: '#100d12',
    height: '2.3em',
    marginBottom: '1em',
    marginLeft: '1.5em',
    marginRight: '1.5em',
    marginTop: '0.55em'
  }

  const itemCraftedWeaponProgressBarStyle = {
    display: 'flex',
    position: 'relative',
    width: item_craftedWeaponProgressBarPercentageValue + '%',
    height: '100%',
    backgroundColor: '#d35137'
  }

  const itemCraftedWeaponProgressBarTextStyle = {
    display: 'grid',
    alignContent: 'center',
    color: '#ffffff',
    height: '100%',
    position: 'absolute',
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    fontSize: '1.8em',
    letterSpacing: '0.04em',
    textShadow: '2px 2px #782e1f',
    paddingLeft: '0.25em',
    wordSpacing: '0.08em'
  }

  const itemCraftedWeaponProgressBarPercentageStyle = {
    display: 'grid',
    alignContent: 'center',
    color: '#ffffff',
    height: '100%',
    position: 'absolute',
    right: '0.2em',
    letterSpacing: '0.04em',
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    fontSize: '1.8em'
  }

  const itemKillTrackerBoxStyle = {
    display: 'flex',
    position: 'relative',
    height: '3.48em',
    marginBottom: '0.25em',
    marginLeft: '0.9em',
    marginRight: '1.6em',
  }

  const itemKillTrackerIconStyle = {
    display: 'flex',
    position: 'relative',
    width: '10%',
    height: '100%',
  }

  const itemKillTrackerTextStyle = {
    alignContent: 'center',
    color: item_killTrackerName_text_color,
    position: 'relative',
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    fontSize: '2em',
    letterSpacing: '0.035em',
    paddingLeft: '0.1em',
    lineHeight: '1.60em',
    verticalAlign: 'middle',
    wordSpacing: '0.08em'
  }

  const itemKillTrackerNumberStyle = {
    display: 'grid',
    alignContent: 'center',
    color: item_killTrackerValue_text_color,
    height: '100%',
    position: 'absolute',
    right: '0.2em',
    bottom: '0.09em',
    letterSpacing: '0.04em',
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    fontSize: '2em'
  }

  const statBoxStyle = {
    position: 'relative',
    paddingLeft: '1.4em',
    paddingRight: '1.4em',
    marginTop: '1.35em',
    paddingBottom: '0.7em',
    borderBottom: '0.15em solid #5c5950'
  }

  const statBoxRowStyle = {
    position: 'relative',
    display: 'flex',
    height: '1.5em',
    marginBottom: '0.75em',
  }

  const statBoxRowNameStyle = {
    position: 'relative',
    float: 'left',
    height: '100%',
    width: '41.75%',
    marginRight: '0.45em',
    textAlign: 'right',
    color: '#aaa8a3',
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    fontSize: '1.85em',
    lineHeight: '0.8em',
    letterSpacing: '0.03em',
    wordSpacing: '0.11em'
  }

  const statBoxRowBarStyle = {
    backgroundColor: '#ffffff11',
    position: 'relative',
    display: 'flex',
    float: 'left',
    height: '100%',
    width: '42.75%',
    marginRight: '0.75em',
  }

  const statBoxRowBarBaseStyle = {
    backgroundColor: '#ececea',
    position: 'relative',
    float: 'left',
    height: '100%',
  }

  const statBoxRowBarMasterworkStyle = {
    backgroundColor: '#ceae32',
    position: 'relative',
    float: 'left',
    height: '100%',
  }

  const statBoxRowValueStyle = {
    position: 'relative',
    float: 'left',
    height: '100%',
    width: '8.5%',
    textAlign: 'left',
    fontFamily: 'NHaasGroteskTXPro-65Md, DestinySymbols',
    fontWeight: '100',
    fontSize: '1.75em',
    lineHeight: '0.85em',
    letterSpacing: '0.02em',
  }

  const modBoxStyle = {
    position: 'relative',
    paddingBottom: '0em',
  }

  const modBoxRowStyle = {
    position: 'relative',
    paddingLeft: '1.7em',
    paddingRight: '1.7em',
    paddingTop: '0.5em',
    display: 'flex',
    minHeight: '3.5em',
    paddingBottom: '0.5em'
  }

  const modBoxRowIconBoxStyle = {
    position: 'relative',
    float: 'left',
    width: '8.5%',
    height: '100%',
    marginRight: '0.5em',
    display: 'flex',
  }

  const modBoxRowTextBoxStyle = {
    position: 'relative',
    float: 'left',
    width: '87%',
    paddingLeft: '0.5em'
  }

  const modBoxRowTextBoxNameStyle = {
    textAlign: 'left',
    color: '#eaeaea',
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    fontSize: '1.9em',
    letterSpacing: '0.015em',
    wordSpacing: '0.05em',
    lineHeight: '1.2em'
  }

  const modBoxRowTextBoxDescriptionStyle = {
    textAlign: 'left',
    color: '#b1afaa',
    fontFamily: 'NHaasGroteskTXPro-55Rg, DestinySymbols',
    fontSize: '1.66em',
    fontWeight: '500',
    letterSpacing: '0.001em',
    lineHeight: '1.1em',
    paddingTop: '0.1em'
  }

  const interactBoxStyle = {
    backgroundColor: footer_backgroundColor,
    height: '1.85em',
    color: footer_textColor,
    fontFamily: 'NHaasGroteskDSPro-55Rg, DestinySymbols',
    fontSize: '1.7em',
    lineHeight: '1.9em',
    textAlign: 'right',
    paddingRight: '0.9em',
    wordSpacing: '0em',
    letterSpacing: '0.02em',
    fontWeight: '100',
    whiteSpace: 'pre'
  }

  const coreEditorStyle = {
    position: 'fixed',
    width: '24em',
    height: '100vh',
    paddingLeft: '2em',
    paddingRight: '2em',
    overflowY: 'scroll',
    top: '60px',
    zIndex: '9999999'
  }

  const corePreviewStyle = {
    marginLeft: '30em',
    paddingleft: '2em',
    paddingRight: '2em',
    paddingTop: '2em',
    overflowY: 'scroll',
    position: 'fixed',
    height: '95vh',
    top: '0'
  }

  const mobileEditorStyle = {
    position: 'relative',
    height: '25vh',
    paddingLeft: '2em',
    paddingRight: '2em',
    marginBottom: '2em',
    overflowY: 'scroll',
    zIndex: '9999999',
    resize: 'vertical',
    background: '#FFF no-repeat',
    backgroundImage: '-webkit-radial-gradient(50% 0, farthest-side, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0)), -webkit-radial-gradient(50% 100%, farthest-side, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0))',
    backgroundPosition: '0 0, 0 100%',
    backgroundSize: '100% 14px'
  }

  const mobilePreviewStyle = {
    position: 'relative',
    display: 'block',
    marginTop: '2em',
    top: '0',
  }

  const boxStyle = {
    background: box_background_color,
    width: '42.5em',
    margin: 'auto' // temp
  }

  return (
    <div style={{ width: '100%' }}>
      <div style={isMobile ? mobileEditorStyle : coreEditorStyle}>
        {/*
        One Click Rarity
         */}
        <p>One Click Rarity: </p>
        <ButtonGroup variant="outlined" orientation="vertical" aria-label="text button group">
          <Button onMouseUp={() => layoutSetExotic()}>Exotic</Button>
          <Button onMouseUp={() => layoutSetLegendary()}>Legendary</Button>
          <Button onMouseUp={() => layoutSetRare()}>Rare</Button>
          <Button onMouseUp={() => layoutSetUncommon()}>Uncommon</Button>
          <Button onMouseUp={() => layoutSetCommon()}>Common</Button>
          <Button onMouseUp={() => layoutSetBasic()}>Basic/Dark</Button>
        </ButtonGroup>
        {/*
        =========================================================

                    BASE:

        =========================================================
        */}
        <h1>Base</h1>
        {/*
        Masterwork
         */}
        <FormGroup>
          <FormControlLabel control={<Checkbox />} label="Masterworked?" checked={masterwork} onChange={(e) => set_masterwork(e.target.checked)} />
        </FormGroup><br></br>

        {/*
        Header Background Color
         */}
        <div>
          <input type="color" id="header_background_color" name="header_background_color"
            value={header_background_color} onChange={(e) => set_header_background_color(e.target.value)} ></input>
          <label htmlFor="header_background_color">header_background_color</label>
        </div><br></br>

        {/*
        Box Background Color
         */}
        <div>
          <input type="color" id="box_background_color" name="box_background_color"
            value={box_background_color} onChange={(e) => set_box_background_color(e.target.value)} ></input>
          <label htmlFor="box_background_color">box_background_color</label>
        </div><br></br>

        {/*
        Header Title Text ("Izanagi's Burden")
         */}
        <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="header_title_text" autofill='none' placeholder="Izanagi's Burden" variant="outlined" value={header_title_text} onChange={(e) => set_header_title_text(e.target.value)} /><br></br>

        {/*
        Header Title Text Color
         */}
        <div>
          <input type="color" id="header_title_text_color" name="header_title_text_color"
            value={header_title_text_color} onChange={(e) => set_header_title_text_color(e.target.value)} ></input>
          <label htmlFor="header_title_text_color">header_title_text_color</label>
        </div><br></br>

        {/*
        Header Subtitle Text ("Sniper Rifle")
         */}
        <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="header_subtitle_text" autofill='none' placeholder="Sniper Rifle" variant="outlined" value={header_subtitle_text} onChange={(e) => set_header_subtitle_text(e.target.value)} /><br></br>

        {/*
        Header Subtitle Text Color
         */}
        <div>
          <input type="color" id="header_subtitle_text_color" name="header_subtitle_text_color"
            value={header_subtitle_text_color} onChange={(e) => set_header_subtitle_text_color(e.target.value)} ></input>
          <label htmlFor="header_subtitle_text_color">header_subtitle_text_color</label>
        </div><br></br>

        {/*
        Header Subtitle Rarity Text
         */}
        <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="header_subtitle_rarity_text" autofill='none' placeholder="Exotic" variant="outlined" value={header_subtitle_rarity_text} onChange={(e) => set_header_subtitle_rarity_text(e.target.value)} /><br></br>

        {/*
        Header Subtitle Rarity Text Color
         */}
        <div>
          <input type="color" id="header_subtitle_rarity_text_color" name="header_subtitle_rarity_text_color"
            value={header_subtitle_rarity_text_color} onChange={(e) => set_header_subtitle_rarity_text_color(e.target.value)} ></input>
          <label htmlFor="header_subtitle_rarity_text_color">header_subtitle_rarity_text_color</label>
        </div><br></br>

        {/*
        Header Missing Requirements Warning Text
         */}
        <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="header_missingRequirementWarning_text" autofill='none' placeholder="Requires Warlock Class" variant="outlined" value={header_missingRequirementWarning_text} onChange={(e) => set_header_missingRequirementWarning_text(e.target.value)} /><br></br><br></br>

        {/*
        Header Description
        */}
        <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="header_description" autofill='none' placeholder="Collect Vestiges of Dread" variant="outlined" value={header_description} onChange={(e) => set_header_description(e.target.value)} /><br></br><br></br>
        <hr></hr>

        {/*
        =========================================================

                    ITEM (WEAPON/ARMOR):

        =========================================================
        */}
        <h1>Item (Weapon/Armor)</h1>
        {/*
        Item Weapon Bool
         */}
        <FormGroup>
          <FormControlLabel control={<Checkbox />} label="Item Type?" checked={item_bool} onChange={(e) => set_item_bool(e.target.checked)} />
        </FormGroup>

        {/*
        Item Power Text
         */}
        {item_bool ? <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="item_power_text" autofill='none' placeholder="1570" variant="outlined" value={item_power_text} onChange={(e) => set_item_power_text(e.target.value)} /> : ''}<br></br>

        {/*
        Item Power Text Color
         */}
        {item_bool ? <div>
          <input type="color" id="item_power_text_color" name="item_power_text_color"
            value={item_power_text_color} onChange={(e) => set_item_power_text_color(e.target.value)} ></input>
          <label htmlFor="item_power_text_color">item_power_text_color</label>
        </div> : ''}<br></br>
        {/*
        Item Energy Damage Type
         */}
        {item_bool ? <FormControl>
          <FormLabel id="form_item_energydamagetype">item_energydamagetype</FormLabel>
          <RadioGroup
            aria-labelledby="form_item_energydamagetype"
            defaultValue="none"
            name="formgroup_item_energydamagetype"
          >
            <FormControlLabel value="none" control={<Radio />} label="No Energy Type" onChange={(e) => { set_item_energydamagetype(e.target.value); set_item_power_text_color('#ffffff') }} />
            <FormControlLabel value="arc" control={<Radio />} label="Arc" onChange={(e) => { set_item_energydamagetype(e.target.value); set_item_power_text_color('#79ebf3') }} />
            <FormControlLabel value="solar" control={<Radio />} label="Solar" onChange={(e) => { set_item_energydamagetype(e.target.value); set_item_power_text_color('#f36f26') }} />
            <FormControlLabel value="void" control={<Radio />} label="Void" onChange={(e) => { set_item_energydamagetype(e.target.value); set_item_power_text_color('#b082cb') }} />
            <FormControlLabel value="stasis" control={<Radio />} label="Stasis" onChange={(e) => { set_item_energydamagetype(e.target.value); set_item_power_text_color('#4e87ff') }} />
          </RadioGroup>
        </FormControl> : ''}<br></br>
        {/*
        =========================================================

                    WEAPON:

        =========================================================
        */}

        {item_bool ? <h1>Weapon Type (Ammo related)</h1> : ''}
        {/*
        Item Weapon Bool
         */}
        {item_bool ? <FormGroup>
          <FormControlLabel control={<Checkbox />} label="Weapon Type?" checked={item_weaponTypeBool} onChange={(e) => set_item_weaponTypeBool(e.target.checked)} />
        </FormGroup> : ''}

        {/*
        Weapon Ammo Type
         */}
        {item_bool && item_weaponTypeBool ? (<FormControl>
          <FormLabel id="form_item_weaponammotype">item_weaponammotype</FormLabel>
          <RadioGroup
            aria-labelledby="form_item_weaponammotype"
            defaultValue="special"
            name="formgroup_item_weaponammotype"
          >
            <FormControlLabel value="primary" control={<Radio />} label="Primary" onChange={(e) => { set_item_weaponammotype(e.target.value); set_item_ammotype_text('Primary') }} />
            <FormControlLabel value="special" control={<Radio />} label="Special" onChange={(e) => { set_item_weaponammotype(e.target.value); set_item_ammotype_text('Special') }} />
            <FormControlLabel value="heavy" control={<Radio />} label="Heavy" onChange={(e) => { set_item_weaponammotype(e.target.value); set_item_ammotype_text('Heavy') }} />
          </RadioGroup>
        </FormControl>) : ''}

        {/*
        Item Ammo Type Text
        */}
        {item_bool && item_weaponTypeBool ? (<TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="item_ammotype_text" autofill='none' placeholder="Special" variant="outlined" value={item_ammotype_text} onChange={(e) => set_item_ammotype_text(e.target.value)} />) : ''}

        {/*
        Item Ammo Type Text Color
        */}
        {item_bool && item_weaponTypeBool ? (<div>
          <input type="color" id="item_ammotype_text_color" name="item_ammotype_text_color"
            value={item_ammotype_text_color} onChange={(e) => set_item_ammotype_text_color(e.target.value)} ></input>
          <label htmlFor="item_ammotype_text_color">item_ammotype_text_color</label>
        </div>) : ''}<br></br>

        {/*
        =========================================================

                    ARMOR:

        =========================================================
        */}

        {item_bool ? <h1>Armor Affinity</h1> : ''}
        {/*
        Armor Bool
         */}
        {item_bool ? <FormGroup>
          <FormControlLabel control={<Checkbox />} label="Armor Type?" checked={item_armorbool} onChange={(e) => set_item_armorbool(e.target.checked)} />
        </FormGroup> : ''}<br></br>

        {/*
        Armor Affinity Energy Type
         */}
        {item_bool && item_armorbool ? <FormControl>
          <FormLabel id="form_item_armorAffinitytype">item_armorAffinitytype</FormLabel>
          <RadioGroup
            aria-labelledby="form_item_armorAffinitytype"
            defaultValue="stasis"
            name="formgroup_item_armorAffinitytype"
          >
            <FormControlLabel value="none" control={<Radio />} label="No Energy Type" onChange={(e) => { set_item_armorAffinitytype(e.target.value); set_item_armorAffinity_number_color('#ffffff') }} />
            <FormControlLabel value="arc" control={<Radio />} label="Arc" onChange={(e) => { set_item_armorAffinitytype(e.target.value); set_item_armorAffinity_number_color('#79ebf3') }} />
            <FormControlLabel value="solar" control={<Radio />} label="Solar" onChange={(e) => { set_item_armorAffinitytype(e.target.value); set_item_armorAffinity_number_color('#f36f26') }} />
            <FormControlLabel value="void" control={<Radio />} label="Void" onChange={(e) => { set_item_armorAffinitytype(e.target.value); set_item_armorAffinity_number_color('#b082cb') }} />
            <FormControlLabel value="stasis" control={<Radio />} label="Stasis" onChange={(e) => { set_item_armorAffinitytype(e.target.value); set_item_armorAffinity_number_color('#4e87ff') }} />
          </RadioGroup>
        </FormControl> : ''}<br></br>

        {/*
        Armor Affinity Number
         */}
        {item_bool && item_armorbool ? <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="item_armorAffinity_number_text" autofill='none' placeholder="10" variant="outlined" value={item_armorAffinity_number_text} onChange={(e) => set_item_armorAffinity_number_text(e.target.value)} /> : ''}<br></br><br></br>

        {/*
        Armor Affinity Text
         */}
        {item_bool && item_armorbool ? <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="item_armorAffinity_text" autofill='none' placeholder="Energy" variant="outlined" value={item_armorAffinity_text} onChange={(e) => set_item_armorAffinity_text(e.target.value)} /> : ''}<br></br>
        {/*
        Armor Affinity Text Color
         */}
        {item_bool && item_armorbool ? <div>
          <input type="color" id="item_armorAffinity_text_color" name="item_armorAffinity_text_color"
            value={item_armorAffinity_text_color} onChange={(e) => set_item_armorAffinity_text_color(e.target.value)} ></input>
          <label htmlFor="item_armorAffinity_text_color">item_armorAffinity_text_color</label>
        </div> : ''}<br></br>
        {/*
        =========================================================

                    CRAFTED WEAPON:

        =========================================================
        */}

        {item_bool ? <h1>Crafted Weapon</h1> : ''}

        {/*
        Crafted Weapon Bool
         */}
        {item_bool ? <FormGroup>
          <FormControlLabel control={<Checkbox />} label="Crafted Weapon?" checked={item_craftedBool} onChange={(e) => set_item_craftedBool(e.target.checked)} />
        </FormGroup> : ''}<br></br>

        {/*
        Crafted Weapon Text
         */}
        {item_bool && item_craftedBool ? <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="item_craftedWeaponProgressBarText" autofill='none' placeholder="Weapon Lv. 107" variant="outlined" value={item_craftedWeaponProgressBarText} onChange={(e) => set_item_craftedWeaponProgressBarText(e.target.value)} /> : ''}<br></br><br></br>

        {/*
        Crafted Weapon Percentage Text
         */}
        {item_bool && item_craftedBool ? <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="item_craftedWeaponProgressBarPercentageText" autofill='none' placeholder="68%" variant="outlined" value={item_craftedWeaponProgressBarPercentageText} onChange={(e) => set_item_craftedWeaponProgressBarPercentageText(e.target.value)} /> : ''}<br></br><br></br><br></br>

        {/*
        Crafted Weapon Percentage Value
         */}
        {item_bool && item_craftedBool ? <Slider
          value={item_craftedWeaponProgressBarPercentageValue}
          onChange={(e) => set_item_craftedWeaponProgressBarPercentageValue(e.target.value)}
          step={0.5}
          marks
          min={0}
          max={100}
          valueLabelDisplay="on"
        /> : ''}

        {item_bool ? <h1>Kill Tracker</h1> : ''}
        {/*
        Kill Tracker Bool
         */}
        {item_bool ? <FormGroup>
          <FormControlLabel control={<Checkbox />} label="Kill Tracker?" checked={item_killTracker_bool} onChange={(e) => set_item_killTracker_bool(e.target.checked)} />
        </FormGroup> : ''}<br></br>

        {/*
        Kill Tracker Icon Link
         */}
        {item_bool && item_killTracker_bool ? <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="item_killTrackerIconLink" placeholder="https://www.bungie.net/common/destiny2_content/icons/xxxx.png" variant="outlined" value={item_killTrackerIconLink} onChange={(e) => set_item_killTrackerIconLink(e.target.value)} /> : ''}
        {item_bool && item_killTracker_bool ? <div>
          <Button onClick={handleToggle}>What's this?</Button>
          <Backdrop
            sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
            open={open}
            onClick={handleClose}
          >
            <div style={{ margin: '2em' }}>
              <h2>what's item_killTrackerIconLink?</h2>
              <p>This is a link to an image, typically a direct link to an icon image hosted by Bungie, but it can really be any image.<br></br>For example, the default value is <code>https://www.bungie.net/common/destiny2_content/icons/1c0c674ed40bec52e8e0691f9020beea.png</code><br></br>which links to an image of the guardian crest, an image used for displaying generic enemies defeated.<br></br><br></br>This image is then displayed to the left of the text of the Kill Tracker name, typically "Enemies Defeated".</p>
            </div>
          </Backdrop>
        </div> : ''}
        <br></br>

        {/*
        Kill Tracker Name Text
         */}
        {item_bool && item_killTracker_bool ? <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="item_killTrackerName_text" placeholder="Enemies Defeated" variant="outlined" value={item_killTrackerName_text} onChange={(e) => set_item_killTrackerName_text(e.target.value)} /> : ''}<br></br><br></br>
        {/*
        Kill Tracker Name Text Color
         */}
        {item_bool && item_killTracker_bool ? <div>
          <input type="color" id="item_killTrackerName_text_color" name="item_killTrackerName_text_color"
            value={item_killTrackerName_text_color} onChange={(e) => set_item_killTrackerName_text_color(e.target.value)} ></input>
          <label htmlFor="item_killTrackerName_text_color">item_killTrackerName_text_color</label>
        </div> : ''}<br></br>

        {/*
        Kill Tracker Value Text
         */}
        {item_bool && item_killTracker_bool ? <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="item_killTrackerValue_text" placeholder="1,624" variant="outlined" value={item_killTrackerValue_text} onChange={(e) => set_item_killTrackerValue_text(e.target.value)} /> : ''}<br></br><br></br>
        {/*
        Kill Tracker Value Text Color
         */}
        {item_bool && item_killTracker_bool ? <div>
          <input type="color" id="item_killTrackerValue_text_color" name="item_killTrackerValue_text_color"
            value={item_killTrackerValue_text_color} onChange={(e) => set_item_killTrackerValue_text_color(e.target.value)} ></input>
          <label htmlFor="item_killTrackerValue_text_color">item_killTrackerValue_text_color</label>
        </div> : ''}<br></br>
        {/*
        =========================================================

                    STAT BOX:

        =========================================================
        */}

        {item_bool ? <h1>Stat Box</h1> : ''}

        {/*
        Enable StatBox
         */}
        {item_bool ? <FormGroup>
          <FormControlLabel control={<Checkbox />} label="Stat Box?" checked={item_statBox_bool} onChange={(e) => set_item_statBox_bool(e.target.checked)} />
        </FormGroup> : ''}<br></br>

        {item_bool && item_statBox_bool ? <div>

          <h2>Stat1:</h2>
          {/*
          STAT1 NAME
          */}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat1_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat1_name_text} onChange={(e) => set_item_statBox_stat1_name_text(e.target.value)} /><br></br>

          {/*
          STAT1 BARBASE
          */}
          <p>item_statBox_stat1_barBase_value</p>
          <Slider
            value={item_statBox_stat1_barBase_value}
            onChange={(e) => set_item_statBox_stat1_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
          STAT1 MASTERWORK
          */}
          <p>item_statBox_stat1_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat1_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat1_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
          STAT1 VALUE TEXT
          */}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat1_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat1_value_text} onChange={(e) => set_item_statBox_stat1_value_text(e.target.value)} /><br></br>
          {/*
          STAT1 VALUE MASTERWORK
          */}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat1_value_masterwork} onChange={(e) => set_item_statBox_stat1_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}

        {item_bool && item_statBox_bool && item_statBox_stat1_name_text ? <div>

          <h2>stat2:</h2>
          {/*
stat2 NAME
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat2_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat2_name_text} onChange={(e) => set_item_statBox_stat2_name_text(e.target.value)} /><br></br>

          {/*
stat2 BARBASE
*/}
          <p>item_statBox_stat2_barBase_value</p>
          <Slider
            value={item_statBox_stat2_barBase_value}
            onChange={(e) => set_item_statBox_stat2_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
stat2 MASTERWORK
*/}
          <p>item_statBox_stat2_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat2_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat2_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
stat2 VALUE TEXT
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat2_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat2_value_text} onChange={(e) => set_item_statBox_stat2_value_text(e.target.value)} /><br></br>
          {/*
stat2 VALUE MASTERWORK
*/}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat2_value_masterwork} onChange={(e) => set_item_statBox_stat2_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}

        {item_bool && item_statBox_bool && item_statBox_stat2_name_text ? <div>

          <h2>stat3:</h2>
          {/*
stat3 NAME
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat3_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat3_name_text} onChange={(e) => set_item_statBox_stat3_name_text(e.target.value)} /><br></br>

          {/*
stat3 BARBASE
*/}
          <p>item_statBox_stat3_barBase_value</p>
          <Slider
            value={item_statBox_stat3_barBase_value}
            onChange={(e) => set_item_statBox_stat3_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
stat3 MASTERWORK
*/}
          <p>item_statBox_stat3_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat3_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat3_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
stat3 VALUE TEXT
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat3_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat3_value_text} onChange={(e) => set_item_statBox_stat3_value_text(e.target.value)} /><br></br>
          {/*
stat3 VALUE MASTERWORK
*/}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat3_value_masterwork} onChange={(e) => set_item_statBox_stat3_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}

        {item_bool && item_statBox_bool && item_statBox_stat3_name_text ? <div>

          <h2>stat4:</h2>
          {/*
stat4 NAME
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat4_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat4_name_text} onChange={(e) => set_item_statBox_stat4_name_text(e.target.value)} /><br></br>

          {/*
stat4 BARBASE
*/}
          <p>item_statBox_stat4_barBase_value</p>
          <Slider
            value={item_statBox_stat4_barBase_value}
            onChange={(e) => set_item_statBox_stat4_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
stat4 MASTERWORK
*/}
          <p>item_statBox_stat4_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat4_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat4_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
stat4 VALUE TEXT
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat4_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat4_value_text} onChange={(e) => set_item_statBox_stat4_value_text(e.target.value)} /><br></br>
          {/*
stat4 VALUE MASTERWORK
*/}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat4_value_masterwork} onChange={(e) => set_item_statBox_stat4_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}

        {item_bool && item_statBox_bool && item_statBox_stat4_name_text ? <div>

          <h2>stat5:</h2>
          {/*
stat5 NAME
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat5_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat5_name_text} onChange={(e) => set_item_statBox_stat5_name_text(e.target.value)} /><br></br>

          {/*
stat5 BARBASE
*/}
          <p>item_statBox_stat5_barBase_value</p>
          <Slider
            value={item_statBox_stat5_barBase_value}
            onChange={(e) => set_item_statBox_stat5_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
stat5 MASTERWORK
*/}
          <p>item_statBox_stat5_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat5_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat5_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
stat5 VALUE TEXT
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat5_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat5_value_text} onChange={(e) => set_item_statBox_stat5_value_text(e.target.value)} /><br></br>
          {/*
stat5 VALUE MASTERWORK
*/}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat5_value_masterwork} onChange={(e) => set_item_statBox_stat5_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}

        {item_bool && item_statBox_bool && item_statBox_stat5_name_text ? <div>

          <h2>stat6:</h2>
          {/*
stat6 NAME
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat6_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat6_name_text} onChange={(e) => set_item_statBox_stat6_name_text(e.target.value)} /><br></br>

          {/*
stat6 BARBASE
*/}
          <p>item_statBox_stat6_barBase_value</p>
          <Slider
            value={item_statBox_stat6_barBase_value}
            onChange={(e) => set_item_statBox_stat6_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
stat6 MASTERWORK
*/}
          <p>item_statBox_stat6_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat6_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat6_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
stat6 VALUE TEXT
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat6_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat6_value_text} onChange={(e) => set_item_statBox_stat6_value_text(e.target.value)} /><br></br>
          {/*
stat6 VALUE MASTERWORK
*/}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat6_value_masterwork} onChange={(e) => set_item_statBox_stat6_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}

        {item_bool && item_statBox_bool && item_statBox_stat6_name_text ? <div>

          <h2>stat7:</h2>
          {/*
stat7 NAME
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat7_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat7_name_text} onChange={(e) => set_item_statBox_stat7_name_text(e.target.value)} /><br></br>

          {/*
stat7 BARBASE
*/}
          <p>item_statBox_stat7_barBase_value</p>
          <Slider
            value={item_statBox_stat7_barBase_value}
            onChange={(e) => set_item_statBox_stat7_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
stat7 MASTERWORK
*/}
          <p>item_statBox_stat7_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat7_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat7_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
stat7 VALUE TEXT
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat7_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat7_value_text} onChange={(e) => set_item_statBox_stat7_value_text(e.target.value)} /><br></br>
          {/*
stat7 VALUE MASTERWORK
*/}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat7_value_masterwork} onChange={(e) => set_item_statBox_stat7_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}

        {item_bool && item_statBox_bool && item_statBox_stat7_name_text ? <div>

          <h2>stat8:</h2>
          {/*
stat8 NAME
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat8_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat8_name_text} onChange={(e) => set_item_statBox_stat8_name_text(e.target.value)} /><br></br>

          {/*
stat8 BARBASE
*/}
          <p>item_statBox_stat8_barBase_value</p>
          <Slider
            value={item_statBox_stat8_barBase_value}
            onChange={(e) => set_item_statBox_stat8_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
stat8 MASTERWORK
*/}
          <p>item_statBox_stat8_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat8_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat8_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
stat8 VALUE TEXT
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat8_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat8_value_text} onChange={(e) => set_item_statBox_stat8_value_text(e.target.value)} /><br></br>
          {/*
stat8 VALUE MASTERWORK
*/}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat8_value_masterwork} onChange={(e) => set_item_statBox_stat8_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}

        {item_bool && item_statBox_bool && item_statBox_stat8_name_text ? <div>

          <h2>stat9:</h2>
          {/*
stat9 NAME
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat9_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat9_name_text} onChange={(e) => set_item_statBox_stat9_name_text(e.target.value)} /><br></br>

          {/*
stat9 BARBASE
*/}
          <p>item_statBox_stat9_barBase_value</p>
          <Slider
            value={item_statBox_stat9_barBase_value}
            onChange={(e) => set_item_statBox_stat9_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
stat9 MASTERWORK
*/}
          <p>item_statBox_stat9_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat9_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat9_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
stat9 VALUE TEXT
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat9_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat9_value_text} onChange={(e) => set_item_statBox_stat9_value_text(e.target.value)} /><br></br>
          {/*
stat9 VALUE MASTERWORK
*/}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat9_value_masterwork} onChange={(e) => set_item_statBox_stat9_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}

        {item_bool && item_statBox_bool && item_statBox_stat9_name_text ? <div>

          <h2>stat10:</h2>
          {/*
stat10 NAME
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat10_name_text" autofill='none' placeholder="Impact" variant="outlined" value={item_statBox_stat10_name_text} onChange={(e) => set_item_statBox_stat10_name_text(e.target.value)} /><br></br>

          {/*
stat10 BARBASE
*/}
          <p>item_statBox_stat10_barBase_value</p>
          <Slider
            value={item_statBox_stat10_barBase_value}
            onChange={(e) => set_item_statBox_stat10_barBase_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />

          {/*
stat10 MASTERWORK
*/}
          <p>item_statBox_stat10_barMasterwork_value</p>
          <Slider
            value={item_statBox_stat10_barMasterwork_value}
            onChange={(e) => set_item_statBox_stat10_barMasterwork_value(e.target.value)}
            step={0.5}
            marks
            min={0}
            max={100}
            valueLabelDisplay="on"
          />
          {/*
stat10 VALUE TEXT
*/}
          <TextField sx={{
            '& .MuiOutlinedInput-root': {
              fontFamily: 'Helvetica, DestinySymbols'
            }
          }} label="item_statBox_stat10_value_text" autofill='none' placeholder="70" variant="outlined" value={item_statBox_stat10_value_text} onChange={(e) => set_item_statBox_stat10_value_text(e.target.value)} /><br></br>
          {/*
stat10 VALUE MASTERWORK
*/}
          <FormGroup>
            <FormControlLabel control={<Checkbox />} label="Masterworked Value?" checked={item_statBox_stat10_value_masterwork} onChange={(e) => set_item_statBox_stat10_value_masterwork(e.target.checked)} />
          </FormGroup>
          <br></br>
          <hr></hr>
          <br></br>
        </div> : ''}
        <br></br><br></br>

        {/*
        =========================================================

                    MOD BOX:

        =========================================================
        */}

        {item_bool ? <h1>Mod Box</h1> : ''}

        {/*
        Enable ModBox
        */}
        {item_bool ? <FormGroup>
          <FormControlLabel control={<Checkbox />} label="Mod Box?" checked={item_modBox_bool} onChange={(e) => set_item_modBox_bool(e.target.checked)} />
        </FormGroup> : ''}<br></br>

        {/* Mod1 */}
        {item_bool && item_modBox_bool ?
          <div>
            <h2>Mod1:</h2>
            {/*
            MOD1 Icon Link
            */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod1_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod1_iconLink} onChange={(e) => set_item_modBox_mod1_iconLink(e.target.value)} /><br></br><br></br>
            {/*
            MOD1 Name Text
            */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod1_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod1_name_text} onChange={(e) => set_item_modBox_mod1_name_text(e.target.value)} /><br></br><br></br>
            {/*
            MOD1 Description (D2Keys)
            */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod1_description_text" variant="outlined" value={item_modBox_mod1_description_text} onChange={(e) => set_item_modBox_mod1_description_text(e.target.value)} /><br></br><br></br>
            {/*
            MOD1 Type
            */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod1_type">item_modBox_mod1_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod1_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod1_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod1_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod1_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod1_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        {/* Mod2 */}
        {item_bool && item_modBox_bool && item_modBox_mod1_name_text ?
          <div>
            <h2>mod2:</h2>
            {/*
    mod2 Icon Link
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod2_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod2_iconLink} onChange={(e) => set_item_modBox_mod2_iconLink(e.target.value)} /><br></br><br></br>
            {/*
    mod2 Name Text
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod2_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod2_name_text} onChange={(e) => set_item_modBox_mod2_name_text(e.target.value)} /><br></br><br></br>
            {/*
    mod2 Description (D2Keys)
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod2_description_text" variant="outlined" value={item_modBox_mod2_description_text} onChange={(e) => set_item_modBox_mod2_description_text(e.target.value)} /><br></br><br></br>
            {/*
    mod2 Type
    */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod2_type">item_modBox_mod2_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod2_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod2_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod2_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod2_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod2_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        {/* Mod3 */}
        {item_bool && item_modBox_bool && item_modBox_mod2_name_text ?
          <div>
            <h2>mod3:</h2>
            {/*
    mod3 Icon Link
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod3_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod3_iconLink} onChange={(e) => set_item_modBox_mod3_iconLink(e.target.value)} /><br></br><br></br>
            {/*
    mod3 Name Text
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod3_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod3_name_text} onChange={(e) => set_item_modBox_mod3_name_text(e.target.value)} /><br></br><br></br>
            {/*
    mod3 Description (D2Keys)
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod3_description_text" variant="outlined" value={item_modBox_mod3_description_text} onChange={(e) => set_item_modBox_mod3_description_text(e.target.value)} /><br></br><br></br>
            {/*
    mod3 Type
    */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod3_type">item_modBox_mod3_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod3_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod3_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod3_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod3_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod3_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        {/* Mod4 */}
        {item_bool && item_modBox_bool && item_modBox_mod3_name_text ?
          <div>
            <h2>mod4:</h2>
            {/*
    mod4 Icon Link
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod4_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod4_iconLink} onChange={(e) => set_item_modBox_mod4_iconLink(e.target.value)} /><br></br><br></br>
            {/*
    mod4 Name Text
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod4_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod4_name_text} onChange={(e) => set_item_modBox_mod4_name_text(e.target.value)} /><br></br><br></br>
            {/*
    mod4 Description (D2Keys)
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod4_description_text" variant="outlined" value={item_modBox_mod4_description_text} onChange={(e) => set_item_modBox_mod4_description_text(e.target.value)} /><br></br><br></br>
            {/*
    mod4 Type
    */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod4_type">item_modBox_mod4_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod4_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod4_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod4_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod4_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod4_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        {/* Mod5 */}
        {item_bool && item_modBox_bool && item_modBox_mod4_name_text ?
          <div>
            <h2>mod5:</h2>
            {/*
    mod5 Icon Link
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod5_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod5_iconLink} onChange={(e) => set_item_modBox_mod5_iconLink(e.target.value)} /><br></br><br></br>
            {/*
    mod5 Name Text
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod5_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod5_name_text} onChange={(e) => set_item_modBox_mod5_name_text(e.target.value)} /><br></br><br></br>
            {/*
    mod5 Description (D2Keys)
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod5_description_text" variant="outlined" value={item_modBox_mod5_description_text} onChange={(e) => set_item_modBox_mod5_description_text(e.target.value)} /><br></br><br></br>
            {/*
    mod5 Type
    */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod5_type">item_modBox_mod5_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod5_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod5_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod5_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod5_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod5_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        {/* Mod6 */}
        {item_bool && item_modBox_bool && item_modBox_mod5_name_text ?
          <div>
            <h2>mod6:</h2>
            {/*
    mod6 Icon Link
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod6_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod6_iconLink} onChange={(e) => set_item_modBox_mod6_iconLink(e.target.value)} /><br></br><br></br>
            {/*
    mod6 Name Text
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod6_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod6_name_text} onChange={(e) => set_item_modBox_mod6_name_text(e.target.value)} /><br></br><br></br>
            {/*
    mod6 Description (D2Keys)
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod6_description_text" variant="outlined" value={item_modBox_mod6_description_text} onChange={(e) => set_item_modBox_mod6_description_text(e.target.value)} /><br></br><br></br>
            {/*
    mod6 Type
    */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod6_type">item_modBox_mod6_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod6_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod6_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod6_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod6_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod6_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        {/* Mod7 */}
        {item_bool && item_modBox_bool && item_modBox_mod6_name_text ?
          <div>
            <h2>mod7:</h2>
            {/*
    mod7 Icon Link
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod7_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod7_iconLink} onChange={(e) => set_item_modBox_mod7_iconLink(e.target.value)} /><br></br><br></br>
            {/*
    mod7 Name Text
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod7_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod7_name_text} onChange={(e) => set_item_modBox_mod7_name_text(e.target.value)} /><br></br><br></br>
            {/*
    mod7 Description (D2Keys)
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod7_description_text" variant="outlined" value={item_modBox_mod7_description_text} onChange={(e) => set_item_modBox_mod7_description_text(e.target.value)} /><br></br><br></br>
            {/*
    mod7 Type
    */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod7_type">item_modBox_mod7_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod7_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod7_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod7_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod7_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod7_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        {/* Mod8 */}
        {item_bool && item_modBox_bool && item_modBox_mod7_name_text ?
          <div>
            <h2>mod8:</h2>
            {/*
    mod8 Icon Link
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod8_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod8_iconLink} onChange={(e) => set_item_modBox_mod8_iconLink(e.target.value)} /><br></br><br></br>
            {/*
    mod8 Name Text
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod8_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod8_name_text} onChange={(e) => set_item_modBox_mod8_name_text(e.target.value)} /><br></br><br></br>
            {/*
    mod8 Description (D2Keys)
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod8_description_text" variant="outlined" value={item_modBox_mod8_description_text} onChange={(e) => set_item_modBox_mod8_description_text(e.target.value)} /><br></br><br></br>
            {/*
    mod8 Type
    */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod8_type">item_modBox_mod8_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod8_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod8_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod8_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod8_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod8_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        {/* Mod9 */}
        {item_bool && item_modBox_bool && item_modBox_mod8_name_text ?
          <div>
            <h2>mod9:</h2>
            {/*
    mod9 Icon Link
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod9_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod9_iconLink} onChange={(e) => set_item_modBox_mod9_iconLink(e.target.value)} /><br></br><br></br>
            {/*
    mod9 Name Text
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod9_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod9_name_text} onChange={(e) => set_item_modBox_mod9_name_text(e.target.value)} /><br></br><br></br>
            {/*
    mod9 Description (D2Keys)
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod9_description_text" variant="outlined" value={item_modBox_mod9_description_text} onChange={(e) => set_item_modBox_mod9_description_text(e.target.value)} /><br></br><br></br>
            {/*
    mod9 Type
    */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod9_type">item_modBox_mod9_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod9_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod9_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod9_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod9_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod9_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        {/* Mod10 */}
        {item_bool && item_modBox_bool && item_modBox_mod9_name_text ?
          <div>
            <h2>mod10:</h2>
            {/*
    mod10 Icon Link
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod10_iconLink" autofill='https:/[...]3f1.png' variant="outlined" value={item_modBox_mod10_iconLink} onChange={(e) => set_item_modBox_mod10_iconLink(e.target.value)} /><br></br><br></br>
            {/*
    mod10 Name Text
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod10_name_text" autofill='Honed Edge' variant="outlined" value={item_modBox_mod10_name_text} onChange={(e) => set_item_modBox_mod10_name_text(e.target.value)} /><br></br><br></br>
            {/*
    mod10 Description (D2Keys)
    */}
            <TextField sx={{
              '& .MuiOutlinedInput-root': {
                fontFamily: 'Helvetica, DestinySymbols'
              }
            }} label="item_modBox_mod10_description_text" variant="outlined" value={item_modBox_mod10_description_text} onChange={(e) => set_item_modBox_mod10_description_text(e.target.value)} /><br></br><br></br>
            {/*
    mod10 Type
    */}
            <FormControl>
              <FormLabel id="form_item_modBox_mod10_type">item_modBox_mod10_type</FormLabel>
              <RadioGroup
                aria-labelledby="form_item_modBox_mod10_type"
                defaultValue="none"
                name="formgroup_item_modBox_mod10_type"
              >
                <FormControlLabel value="normal" control={<Radio />} label="Normal" onChange={(e) => set_item_modBox_mod10_type(e.target.value)} />
                <FormControlLabel value="intrinsic" control={<Radio />} label="Intrinsic" onChange={(e) => set_item_modBox_mod10_type(e.target.value)} />
                <FormControlLabel value="exotic" control={<Radio />} label="Exotic" onChange={(e) => set_item_modBox_mod10_type(e.target.value)} />
              </RadioGroup>
            </FormControl><br></br>
          </div> : ''}

        <h1>Footer</h1>
        {/*
        Footer Text
         */}
        <TextField sx={{
          '& .MuiOutlinedInput-root': {
            fontFamily: 'Helvetica, DestinySymbols'
          }
        }} label="footer_text" placeholder=" Details" variant="outlined" value={footer_text} onChange={(e) => set_footer_text(e.target.value)} /><br></br>

        {/*
        Footer Text Color
         */}
        <div>
          <input type="color" id="footer_textColor" name="footer_textColor"
            value={footer_textColor} onChange={(e) => set_footer_textColor(e.target.value)} ></input>
          <label htmlFor="footer_backgroundColor">footer_textColor</label>
        </div><br></br>

        {/*
        Footer Background Color
         */}
        <div>
          <input type="color" id="footer_backgroundColor" name="footer_backgroundColor"
            value={footer_backgroundColor} onChange={(e) => set_footer_backgroundColor(e.target.value)} ></input>
          <label htmlFor="footer_backgroundColor">footer_backgroundColor</label>
        </div><br></br>

      </div>
      {/*
        =========================================================
        =========================================================
        =========================================================

                    RENDERING OF DESTINYTOOLTIP:

        =========================================================
        =========================================================
        =========================================================
      */}
      <div style={isMobile ? mobilePreviewStyle : corePreviewStyle}>
        <div style={boxStyle}>
          <div style={(masterwork) ? headerBoxStyle_MasterworkStyle : headerBoxStyle}>
            <div style={headerBoxTitleStyle}>
              <span style={{ color: header_title_text_color, margin: '0px', overflowWrap: 'break-word' }}>{header_title_text || " "}</span>
            </div>
            <div style={headerBoxSubTitleBoxStyle}>
              <div style={headerBoxSubTitleStyle}>
                <span style={{ color: header_subtitle_text_color, margin: '0px' }}>{header_subtitle_text || " "}</span>
              </div>
              <div style={headerBoxSubTitleRarityStyle}>
                <span style={{ color: header_subtitle_rarity_text_color, margin: '0px' }}>{header_subtitle_rarity_text}</span>
              </div>
            </div>
          </div>
          {header_missingRequirementWarning_text ? <div style={headerMissingRequirementWarningStyle}>
            <span>{header_missingRequirementWarning_text}</span>
          </div> : ''}
          {header_description ? <div style={descriptionStyle}>{header_description}</div> : ''}
          {item_bool ? <div style={itemPrimaryStatBoxStyle}>
            {item_bool ? <div style={itemPrimaryStatPowerStyle}>
              {item_energydamagetype !== 'none' ? <img src={item_energydamagetype === 'arc' ? img_arcEnergy : item_energydamagetype === 'solar' ? img_solarEnergy : item_energydamagetype === 'void' ? img_voidEnergy : item_energydamagetype === 'stasis' ? img_stasisEnergy : ''} alt='' width='64em' style={{ verticalAlign: '-0.05em', paddingRight: '0.13em' }}></img> : ''}
              <span style={itemPrimaryStatPowerNumberStyle}>{item_power_text}</span>
            </div> : ''}
            {item_bool && item_weaponTypeBool ?
              <div style={itemPrimaryStatAmmoTypeStyle}>
                <img src={item_weaponammotype === 'primary' ? img_primaryAmmo : item_weaponammotype === 'special' ? img_specialAmmo : item_weaponammotype === 'heavy' ? img_heavyAmmo : ''} alt='' width='82em'></img>
                <span style={itemPrimaryStatAmmoTypeTextStyle}>{item_ammotype_text}</span>
              </div>
              : ''}
            {item_bool && item_armorbool ?
              <div style={itemPrimaryStatArmorEnergyTypeStyle}>
                <img src={item_armorAffinitytype === 'arc' ? img_arcEnergy : item_armorAffinitytype === 'solar' ? img_solarEnergy : item_armorAffinitytype === 'void' ? img_voidEnergy : item_armorAffinitytype === 'stasis' ? img_stasisEnergy : ''} alt='' width='30em' style={{ verticalAlign: '0.5em' }}></img>
                <span style={itemEnergyaffinityNumberStyle}>{item_armorAffinity_number_text}</span>
                <span style={{ color: item_armorAffinity_text_color, paddingLeft: '0.56em', verticalAlign: '0.64em' }}>{item_armorAffinity_text}</span>
              </div>
              : ''}
            {item_bool && item_craftedBool ?
              <div style={itemCraftedWeaponProgressBoxStyle}>
                <div style={itemCraftedWeaponProgressBarStyle}></div>
                <span style={itemCraftedWeaponProgressBarTextStyle}>{item_craftedWeaponProgressBarText}</span>
                <span style={itemCraftedWeaponProgressBarPercentageStyle}>{item_craftedWeaponProgressBarPercentageText}</span>
              </div> : ''}
            {item_bool && item_killTracker_bool ? <div style={itemKillTrackerBoxStyle}>
              <div style={itemKillTrackerIconStyle}><img alt='' style={{ height: '75%', marginLeft: 'auto', marginRight: 'auto', marginTop: 'auto', marginBottom: 'auto' }} src={item_killTrackerIconLink || img_placeholderIcon}></img></div>
              <div style={itemKillTrackerTextStyle}>{item_killTrackerName_text}</div>
              <div style={itemKillTrackerNumberStyle}>{item_killTrackerValue_text}</div>
            </div> : ''}
          </div> : ''}
          {item_bool && item_statBox_bool ? <div style={statBoxStyle}>
            {item_statBox_stat1_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat1_name_text}</div>
              {item_statBox_stat1_barBase_value || item_statBox_stat1_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat1_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat1_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat1_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat1_value_text}</div>
            </div> : ''}
            {item_statBox_stat2_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat2_name_text}</div>
              {item_statBox_stat2_barBase_value || item_statBox_stat2_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat2_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat2_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat2_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat2_value_text}</div>
            </div> : ''}
            {item_statBox_stat3_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat3_name_text}</div>
              {item_statBox_stat3_barBase_value || item_statBox_stat3_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat3_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat3_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat3_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat3_value_text}</div>
            </div> : ''}
            {item_statBox_stat4_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat4_name_text}</div>
              {item_statBox_stat4_barBase_value || item_statBox_stat4_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat4_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat4_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat4_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat4_value_text}</div>
            </div> : ''}
            {item_statBox_stat5_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat5_name_text}</div>
              {item_statBox_stat5_barBase_value || item_statBox_stat5_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat5_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat5_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat5_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat5_value_text}</div>
            </div> : ''}
            {item_statBox_stat6_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat6_name_text}</div>
              {item_statBox_stat6_barBase_value || item_statBox_stat6_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat6_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat6_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat6_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat6_value_text}</div>
            </div> : ''}
            {item_statBox_stat7_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat7_name_text}</div>
              {item_statBox_stat7_barBase_value || item_statBox_stat7_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat7_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat7_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat7_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat7_value_text}</div>
            </div> : ''}
            {item_statBox_stat8_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat8_name_text}</div>
              {item_statBox_stat8_barBase_value || item_statBox_stat8_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat8_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat8_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat8_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat8_value_text}</div>
            </div> : ''}
            {item_statBox_stat9_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat9_name_text}</div>
              {item_statBox_stat9_barBase_value || item_statBox_stat9_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat9_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat9_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat9_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat9_value_text}</div>
            </div> : ''}
            {item_statBox_stat10_name_text ? <div style={statBoxRowStyle}>
              <div style={statBoxRowNameStyle}>{item_statBox_stat10_name_text}</div>
              {item_statBox_stat10_barBase_value || item_statBox_stat10_barMasterwork_value ? <div style={statBoxRowBarStyle}>
                <div style={{ ...statBoxRowBarBaseStyle, width: item_statBox_stat10_barBase_value + '%' }}></div>
                <div style={{ ...statBoxRowBarMasterworkStyle, width: item_statBox_stat10_barMasterwork_value + '%' }}></div>
              </div> : ''}
              <div style={{ ...statBoxRowValueStyle, color: item_statBox_stat10_value_masterwork ? '#eec35b' : '#ffffff' }}>{item_statBox_stat10_value_text}</div>
            </div> : ''}
          </div> : ''}
          {item_bool && item_modBox_bool ? <div style={modBoxStyle}>
            {item_modBox_mod1_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod1_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod1_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod1_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod1_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod1_name_text}</div>
                {item_modBox_mod1_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod1_description_text}</div> : ''}
              </div>
            </div> : ''}
            {item_modBox_mod2_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod2_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod2_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod2_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod2_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod2_name_text}</div>
                {item_modBox_mod2_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod2_description_text}</div> : ''}
              </div>
            </div> : ''}
            {item_modBox_mod3_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod3_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod3_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod3_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod3_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod3_name_text}</div>
                {item_modBox_mod3_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod3_description_text}</div> : ''}
              </div>
            </div> : ''}
            {item_modBox_mod4_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod4_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod4_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod4_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod4_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod4_name_text}</div>
                {item_modBox_mod4_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod4_description_text}</div> : ''}
              </div>
            </div> : ''}
            {item_modBox_mod5_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod5_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod5_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod5_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod5_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod5_name_text}</div>
                {item_modBox_mod5_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod5_description_text}</div> : ''}
              </div>
            </div> : ''}
            {item_modBox_mod6_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod6_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod6_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod6_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod6_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod6_name_text}</div>
                {item_modBox_mod6_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod6_description_text}</div> : ''}
              </div>
            </div> : ''}
            {item_modBox_mod7_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod7_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod7_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod7_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod7_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod7_name_text}</div>
                {item_modBox_mod7_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod7_description_text}</div> : ''}
              </div>
            </div> : ''}
            {item_modBox_mod8_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod8_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod8_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod8_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod8_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod8_name_text}</div>
                {item_modBox_mod8_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod8_description_text}</div> : ''}
              </div>
            </div> : ''}
            {item_modBox_mod9_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod9_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod9_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod9_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod9_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod9_name_text}</div>
                {item_modBox_mod9_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod9_description_text}</div> : ''}
              </div>
            </div> : ''}
            {item_modBox_mod10_name_text ? <div style={{ ...modBoxRowStyle, backgroundColor: item_modBox_mod10_type === 'normal' ? '' : '#ffffff11' }}>
              <div style={modBoxRowIconBoxStyle}><img alt='' src={item_modBox_mod10_iconLink || img_placeholderIcon} style={{ width: '100%' }}></img></div>
              <div style={modBoxRowTextBoxStyle}>
                <div style={{
                  ...modBoxRowTextBoxNameStyle, color: item_modBox_mod10_type === 'exotic' ? '#e6d64e' : '#eaeaea',
                  paddingTop: item_modBox_mod10_description_text ? '0em' : '0.2em'
                }}>{item_modBox_mod10_name_text}</div>
                {item_modBox_mod10_description_text ? <div style={modBoxRowTextBoxDescriptionStyle}>{item_modBox_mod10_description_text}</div> : ''}
              </div>
            </div> : ''}
          </div> : ''}
          {footer_text ? <div style={interactBoxStyle}>{footer_text}</div> : ''}
        </div>
      </div>
    </div>
  )
}

DestinyTooltip.defaultProps = {
  masterwork: false,
  header_title_text: 'No title',
  header_title_text_color: '#ffffff',
  header_subtitle_text: 'No subtitle',
  header_subtitle_text_color: '#e5d9af',
  header_subtitle_rarity_text: 'No rarity.',
  header_subtitle_rarity_text_color: '#e2d04c',
  item_power_text: '1567',
  item_power_text_color: '#ffffff',
  item_ammotype_text: 'Special',
}

DestinyTooltip.propTypes = {
  masterwork: PropTypes.bool.isRequired,
  header_title_text: PropTypes.string.isRequired,
  header_title_text_color: PropTypes.string.isRequired,
  header_subtitle_text: PropTypes.string.isRequired,
  header_subtitle_text_color: PropTypes.string.isRequired
}

export default DestinyTooltip